import { Component, OnInit } from '@angular/core';
import { ReportConfigurationService } from "src/app/shared/services/report-configuration.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as _moment from 'moment';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Messages } from 'src/app/shared/Validations/messages';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import { validationmethod } from 'src/app/shared/Validations/Validationmethods';
//import {ReportSaveComponent} from './report-save/report-save.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

const moment =  _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}

export interface ArrangeTypeOrderBy {
  name: string,
  value: string
}

export interface AggregateDataBy {
  name: string,
  value: string
}


@Component({
    selector: 'app-veevareporting',
    templateUrl: './veevareporting.component.html',
    styleUrls: ['./veevareporting.component.scss'],
    standalone: false
})
export class VeevareportingComponent implements OnInit {

  //ngModel
  whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "","enterValueWhereDate":"","logicalOperatorWhere": "" };

  barArray = { "type": "column", "xKey": "", "yKeys": "","grouped":"true","label": "{}","strokeWidth":"0" };

  groupByData = { "fieldsGroupBy": "" };

  orderByData = { "fieldsOrderBy": "", "arrangeOrderBy": "" };

  aggregateByData = {"fieldsAggregateBy": "", "arrangeaggregateBy": "" };

  reportingObject = { "from": "", "queryArray": [], "join": [], "firstJoin": [], "secondJoin": [], "thirdJoin": [], "fourthJoin": [] };

   reportingObjectSend = {"reportMainConfigurationId":"","object":"", "queryArray": [], "from":"", "joins": [], "where":[], "groupBy": [], "orderBy": [] ,"type":"","name":"","userAccess":"","aggregateBy":[]};

  

  columnDefsForObjects;

  //columnDefsForTables;

  columnDefsForTablesFields;

  columnDefsForReportingConfiguration;

  rowSelection;

  rowSelectionForTablesFields;

  //gridApi;

  gridApiForTablesFields;

  gridApiForReportingConfiguration;

  tablesFields = [];
  tableFields = [];

  defaultColDefs;
  defaultColDef;
  components;
  ngModelObjectTemporary;
  value;


  ngModelObjectDivision = [];

  // tableNames = [];
  // join = [];
  // firstJoin = [];
  // secondJoin = [];
  // thirdJoin = [];
  // fourthJoin = [];
  // from = [];
  whereValueDateFormat = moment(null)

  selectedObject;

  //selectedTable;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  pageSize;

  screenNames;

  columnNames = [];

  rowsData: any = [];

  formValidWhere: UntypedFormGroup;

  validationMessagesWhere;

  fieldsData: any = [];

  fieldsTemp:any = [];

  aggregateArray: any = [];

  where = [];

  formValidGroupBy: UntypedFormGroup;

  validationMessagesGroupBy;

  groupBy = [];

  formValidOrderBy: UntypedFormGroup;

  validationMessagesOrderBy;

  xdummydata:String;

  show: boolean = false;
  orderByShow: boolean = false;
  aggreageShow:boolean = false;
  fieldChange:boolean = true;
  dateChange:boolean = false;
  showFilter:boolean = false;
  showOrderBy:boolean = false;
  showAggregate:boolean = false;
  saveButton:boolean = true;
  updateButton:boolean = false;
  showgridData:boolean = true;
  barChartData:boolean = false;
  pieChartData:boolean = false;
  showChartData:boolean = false;

   tableNames = [];
   tableNamestemp=[];
   keyStrings = [];
   aggretaefields=[];
   temp = [];
   group = [];
   aliasString
   aggregateValue
   xKeydata:any = [];
   ykeydata:any = []


  getdata: any = []

  orderBy = [];

  xdata = [];

  eachBar = [];

  aggregateBy = [];

  editData;

  xAxis1;
  yAxis1;

  editresponse:any = []

  gridApi;

  options: any;

  backgroundColorButton = "";

  eachxdata

  beverageSpending = [
    {
        beverage: 'Coffee',
        Q1: 10,
        Q2: 50,
        Q3: 60,
        Q4: 70,
    },
    {
        beverage: 'Tea',
        Q1: 20,
        Q2: 30,
        Q3: 40,
        Q4: 50,
    },
    {
        beverage: 'Milk',
        Q1: 10,
        Q2: 10,
        Q3: 10,
        Q4: 20,
    },
];

  constructor(private localStorageSettings: LocalStorageSettingsService, private service: ReportConfigurationService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private validation: validationmethod, public dialogref: MatDialogRef<VeevareportingComponent>,
    private msg: Messages, private formFieldsTrimer: FormFieldsTrimer,private route:ActivatedRoute,private router: Router) {

    //messages for validations
    this.validationMessagesWhere = this.msg.whereMessages;

    this.validationMessagesGroupBy = this.msg.groupByMessages;

    this.validationMessagesGroupBy = this.msg.orderByMessages;
  }

  ngOnInit() {

    // form validations
    this.formValidationsWhere();

    this.formValidationsGroupBy();

    this.formValidationsOrderBy();

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    this.columnDefsForObjects = [
      {
        headerName: "Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Objects : " + params.value,
        field: "object",
        filter: "agTextColumnFilter",
        width: 640,
      }
    ];

    /*this.columnDefsForTables = [
      {
        headerName: "Tables",
        headerTooltip: "Tables",
        tooltipValueGetter: params => "Tables : " + params.value,
        field: "tableName",
        filter: "agTextColumnFilter",
        width: 320
      }
    ];*/

    this.columnDefsForTablesFields = [
      {
        headerName: "Fields",
        headerTooltip: "Fields",
        tooltipValueGetter: params => "Fields : " + params.value,
        field: "attributeNameAndFields",
        filter: "agTextColumnFilter",
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        width: 640,

      }
    ];

    this.rowSelection = "single";

    this.rowSelectionForTablesFields = "multiple";

    this.defaultColDefs = {
      sortable: true,
      resizable: true,
      filter: true
    };

    this.paginationPageSize = 10;

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    }

    //If the record has status==no, row color will change.
    // this.rowClassRules = {
    //   sick: function (params) {
    //     var numSickDays = params.node.data.status;
    //     return numSickDays === "No" || numSickDays === null;
    //   }
    // }
    this.route.params.subscribe(params=>{
      this.editData = params.data;
      //this.editIcon(this.editData);
    });
    console.log(this.editData)
    if(this.editData !== undefined){
      this.editIcon(this.editData);
    }
  }

  editIcon(update){
  //   this.saveButton = false;
  // this.updateButton = true;
  //   console.log(update)
  //   this.service.editReportingData(update).subscribe(res => {

  //     this.spinner.start();

  //     console.log(res);

  //     // checking if response is true or not
  //     if (res.error === true) {

  //       this.spinner.stop();

  //       this.snackbar.open(res.message, "OK", { duration: 5000 });

  //       //params.api.setGridOption('rowData', []);

  //     } else {

  //       this.spinner.stop();
  //       this.editresponse = res;
  //       //params.api.setGridOption('rowData', res);
  //       console.log(this.editresponse.where)
  //       this.cellClickedObjects(this.editresponse,1)
  //       for(let w=0;w<this.editresponse.where.length;w++){
  //       this.where.push(this.editresponse.where[w]);
  //       this.showFilter= true;
  //       }
  //       for(let o=0;o<this.editresponse.orderBy.length;o++){
          
  //         this.orderBy.push(this.editresponse.orderBy[o]);
  //         this.showOrderBy= true;
  //         }
  //         for(let a=0;a<this.editresponse.aggregateBy.length;a++){
  //           this.aggregateBy.push(this.editresponse.aggregateBy[a]);
  //           this.showAggregate= true;
  //           }
  //       console.log(this.where)
  //     }

  //   });
  }



  onGridReadyForObjects(params) {
    this.gridApi = params.api
    this.service.retrieveObjects().subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        params.api.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.gridApi.setGridOption('rowData', res);

        console.log(this.editresponse)
        if (this.editresponse.object != undefined) {
          this.gridApi.forEachNode(node => {
              console.log(node.data)
              console.log(this.editresponse.object)
              if(node.data.object== this.editresponse.object){
                node.setSelected(true)
              }
             
    
    
          });
        }


      }

    });

  }

  cellClickedFields(e){
    console.log(e)
  }

  onRowSelected(event) {
    console.log(event.data);
    console.log(event.node.selected);
    console.log(event.rowIndex);
    console.log(this.aggregateArray);
    if(event.node.selected == true){
      this.aggregateArray.push(event.data)
      this.reportingObjectSend.from = event.data.tableNames
      console.log(this.reportingObjectSend.from)
    } 
    if(event.node.selected == false){
      let contain = this.aggregateArray.includes(event.data);
    console.log(contain)
    if(contain == true){
      this.aggregateArray.splice(this.aggregateArray.indexOf(event.data),1)
    }
    if(this.reportingObjectSend.from == event.data){
      this.reportingObjectSend.from =""; 
    }
      // this.aggregateArray.splice(event.data,1)
    }
  }

  onselection(params){
    console.log(params)
  }

  /*onGridReadyForTables(params) {

    this.gridApi = params.api;

    params.api.setGridOption('rowData', []);

  }*/

  onGridReadyForTablesFields(params, tableName) {

    this.gridApiForTablesFields = params.api;
    console.log(this.gridApiForTablesFields)
    params.api.setGridOption('rowData', []);
    this.fieldsData = this.gridApiForTablesFields.getSelectedRows();

  }

  cellClickedObjects(e,type) {
    console.log(type)
    let selectedObject = e.value
    if(type==1){
      this.reportingObjectSend.object = e.object;  
      console.log(this.reportingObjectSend.object)
      selectedObject = this.reportingObjectSend.object
    }else{
    this.reportingObjectSend.object = e.value;
    selectedObject = e.value
    }
    this.service.retrieveTablesFields(selectedObject).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.gridApiForTablesFields.setGridOption('rowData', []);

      } else {

        this.spinner.stop();
        this.getdata=[]
        this.fieldsTemp=[]
        this.aggregateArray = []
        this.getdata = res;

        for (let l = 0; l < this.getdata.length; l++) {
          this.fieldsTemp.push(this.getdata[l])
          
       
        }
        console.log(this.fieldsTemp)
        console.log(e)
        this.selectedFields(this.fieldsTemp)
        this.gridApiForTablesFields.setGridOption('rowData', res);
        if (e.queryArray != undefined) {
          this.gridApiForTablesFields.forEachNode(node => {
            for (var i = 0; i < e.queryArray.length; i++) {
              console.log(node)
              console.log(e.queryArray[i])
              if(node.data.townshipNameAndFields== e.queryArray[i]){
                node.setSelected(true)
              }
            }
              for (var i = 0; i < e.aggregateBy.length; i++) {
                console.log(node)
                console.log(e.aggregateBy[i].aggregateKey)
                if(node.data.townshipNameAndFields== e.aggregateBy[i].aggregateKey){
                  node.setSelected(true)
                }
             }
    
    
          });
          this.run(this.editresponse)
        }
        this.selectedObject = e.value;

        this.columnDefsForReportingConfiguration = [];

        this.gridApiForReportingConfiguration.setGridOption('rowData', []);

      }

    });
  

  }
  selectedFields(data) {
    console.log(data)
    this.fieldsData = data

    console.log(this.fieldsData);

  }

  /*cellClickedTables(e) {

    console.log(e);

    console.log(e.value)

    this.service.retrieveTablesFields(this.selectedObject).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.gridApi.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.gridApiForTablesFields.setGridOption('rowData', res);

        this.selectedTable = e.value;

      }

    });

  }*/

  // cellClickedTablesFields(e) {

  //   console.log(e);

  //   let tableNameTemp = e.rowData.tableName;

  //   let fieldNameTemp = e.rowData.columnName;

  //   console.log(tableNameTemp);

  //   console.log(fieldNameTemp);

  //   console.log(this.tableNames);

  //   console.log(this.tablesFields);

  //   let index = this.tableNames.indexOf(tableNameTemp);
  //   console.log(index);
  //   this.tableFields = this.tablesFields[index];
  //   console.log(this.tableFields.length)
  //   let queryArray = [];

  //   for (let i = 0; i < this.tableFields.length; i++) {
  //     console.log(this.tableFields[i].columnName)
  //     let temp = tableNameTemp.concat(".");

  //     queryArray.push(temp.concat(this.tableFields[i].columnName));
  //     this.reportingObject.queryArray = queryArray;

  //   }

  //   console.log(queryArray);

  //   let dialogRef = this.dialog.open(ReportConfigurationLinkComponent, { panelClass: 'full-width-dialog', data: { tablesData: this.tableNames, fieldsData: this.tablesFields, tableName: tableNameTemp, fieldName: fieldNameTemp }, disableClose: true });

  //   // subcribe the popup after close
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(result)
  //     if (result != undefined) {

  //       this.thirdJoin.push(result.thirdJoin);
  //       this.fourthJoin.push(result.fourthJoin);
  //       this.join.push(result.join);
  //       if (result.thirdJoin != undefined) {
  //         this.firstJoin.push(e.rowData.tableName);
  //         this.secondJoin.push(e.rowData.columnName);
  //       }
  //       this.reportingObject.firstJoin = this.firstJoin
  //       this.reportingObject.secondJoin = this.secondJoin
  //       this.reportingObject.thirdJoin = this.thirdJoin
  //       this.reportingObject.fourthJoin = this.fourthJoin
  //       this.reportingObject.join = this.join
  //     }
  //     console.log(this.firstJoin);
  //     console.log(this.secondJoin);
  //     console.log(this.thirdJoin);
  //     console.log(this.fourthJoin);
  //     console.log(this.join)
  //   });

  // }

  whereKey(e){
    this.fieldChange = true;
    this.dateChange=false;
    console.log(e)
    console.log(this.fieldsData)
    for(let i=0;i<this.fieldsData.length;i++){
      if(this.fieldsData[i].townshipNameAndFields == e){
        if(this.fieldsData[i].datatype == "Date"){
          this.dateChange=!this.dateChange;
          this.fieldChange = false;
        }else{
          this.dateChange=false;
        }
        }
      }
    }

  run(int) {
    console.log(int)
    console.log(this.gridApiForTablesFields);

    let selectedRows = this.gridApiForTablesFields.getSelectedRows();
    console.log(selectedRows.length)
    if(selectedRows.length == 0){
      this.snackbar.open("Please select atleast one field", "OK", { duration: 5000 });
    }else{
    console.log(selectedRows);

    let tableFieldNames = [];

    let tableFields = [];

     this.tableNames = [];
     this.tableNamestemp = [];
     this.keyStrings = [];
     this.aggretaefields=[];
     this.temp = [];
     this.group = [];
     this.xKeydata = [];
     this.ykeydata = [];

     console.log(this.xKeydata)
     console.log(this.ykeydata)

    for (let i = 0; i < selectedRows.length; i++) {
      tableFieldNames.push(selectedRows[i].townshipNameAndFields);
      this.keyStrings.push(selectedRows[i].townshipFieldsDescription);
     console.log(tableFieldNames)
      if (this.tableNamestemp.indexOf(selectedRows[i].tableNames) == -1) {

        this.tableNamestemp.push(selectedRows[i].tableNames);
        console.log(this.tableNamestemp.length)
        if(this.tableNamestemp.length>1){
          this.tableNames = this.tableNamestemp;
        }

      }
    }
    for(let M=0;M< this.aggregateBy.length;M++){
      this.aggretaefields.push(this.aggregateBy[M].aggregateKey);
      console.log(this.aggretaefields)
    }
      for(let j=0;j< tableFieldNames.length;j++){
        console.log(tableFieldNames[j])
        if(this.aggretaefields.includes(tableFieldNames[j])){
          for(let h=0;h<this.aggretaefields.length;h++){
            console.log(this.aggretaefields[h])
            if(this.aggretaefields[h]==tableFieldNames[j]){
              this.aggregateValue = this.aggregateBy[h].aggregate
              this.aliasString = this.keyStrings[j];
              this.ykeydata.push(this.aliasString)
              this.temp.push(this.aggregateValue+"("+tableFieldNames[j]+")"+" "+"AS "+this.aliasString)
            }
          }
        }else{
          console.log("Nope")
          this.xKeydata.push(this.keyStrings[j])
          tableFields.push(tableFieldNames[j])
          this.group.push(tableFieldNames[j])
        }
      }
      for(let N=0;N<this.temp.length;N++){
        
      tableFields.push(this.temp[N])
      }

    

      if(int  == 0){
     this.reportingObjectSend = {"reportMainConfigurationId":"","queryArray": tableFields, /*"from": this.selectedTable,*/ "joins": this.tableNames, "where": this.where, "groupBy": this.group, "orderBy": this.orderBy,"type":"run","name":"","userAccess":"","object":this.reportingObjectSend.object,"aggregateBy":this.aggregateBy,"from":this.reportingObjectSend.from };

    console.log(this.reportingObjectSend);
    this.executerunQuery(this.reportingObjectSend)
    }
  else{
    this.reportingObjectSend = {"reportMainConfigurationId":"", "queryArray": int.queryArray, /*"from": this.selectedTable,*/ "joins": int.joins, "where": this.where, "groupBy": int.groupBy, "orderBy": this.orderBy,"type":"run","name":"","userAccess":"","object":this.reportingObjectSend.object,"aggregateBy":this.aggregateBy,"from":this.reportingObjectSend.from };
    console.log(this.reportingObjectSend)
    this.executerunQuery(this.reportingObjectSend)
  }
}


  }

  executerunQuery(runData){
    // this.service.retrieverunquery(runData).subscribe(res => {

    //   this.spinner.start();

    //   console.log(res);

    //   // checking if response is true or not
    //   if (res.error === true) {

    //     this.spinner.stop();

    //     this.snackbar.open(res.message, "OK", { duration: 5000 });

    //     this.columnDefsForReportingConfiguration = [];

    //     this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    //   } else {

    //     this.spinner.stop();

    //     this.rowsData = [];

    //     this.rowsData = res;

    //     if (this.rowsData.length != 0) {

    //       this.columnNames = Object.keys(this.rowsData[0]);

    //       console.log(this.columnNames);

    //     }

    //     /*let dialogRef = this.dialog.open(ReportConfigurationDataComponent, { height: "70vh", width: "70%", data: { columnNames: this.columnNames, rowsData: this.rowsData } });
 
    //     // subcribe the popup after close
    //     dialogRef.afterClosed().subscribe(result => {
 
    //     });*/

    //     this.reportConfigurationRun();

    //   }

    // });
  }
  cancel() {

    this.gridApiForTablesFields.setGridOption('rowData', []);

    this.columnDefsForReportingConfiguration = [];

    this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    this.where = [];

    this.groupBy = [];

    this.orderBy = [];

    this.fieldsData = [];

    this.aggregateBy=[];

    this.aggregateArray=[];

    this.show = false;
    this.orderByShow = false;
    this.aggreageShow = false;
    this.dateChange = false;

  }

  save() {
    this.reportingObjectSend.type="save"
    console.log(this.reportingObjectSend)
    // let dialogRef = this.dialog.open(ReportSaveComponent, {
    //   data: { "edata": this.reportingObjectSend },
    //   disableClose: true
    // });
    //     // Create subscription
    //     dialogRef.afterClosed().subscribe(() => {
    //       this.router.navigateByUrl('/user/Menubar/Home', { skipLocationChange: true }).then(() =>
    //       this.router.navigate(["/user/Menubar/Home/Report-Saved-Component"]));
    //       this.cancel()
    //   });

  }
  chart(){
    this.barChartData = false;
    this.pieChartData = false;
  }

  update(){
    console.log("update")
    // console.log(this.reportingObjectSend)
    // this.reportingObjectSend.reportMainConfigurationId = this.editresponse.reportMainConfigurationId
    //   this.reportingObjectSend.type="update"
    //   this.service.updateReportData(this.reportingObjectSend).subscribe(res => {
    //     this.spinner.start();

    //   console.log(res);

    //   // // checking if response is true or not
    //   // if (res.error === true) {

    //   //   this.spinner.stop();

    //   //   this.snackbar.open(res.message, "OK", { duration: 5000 });

    //   // } else {

    //     this.spinner.stop();
    //     this.snackbar.open("Report Successfully Updated", "OK", { duration: 5000 });
    //     this.router.navigateByUrl('/user/Menubar/Home', { skipLocationChange: true }).then(() =>
    //     this.router.navigate(["/user/Menubar/Home/Report-Saved-Component"]));
    //     this.cancel()
  
    //   });
  }

  /*connect() {

    var obj;

    let dialogRef = this.dialog.open(ConnectComponent, { height: "70vh", width: "40%", data: { edata: obj } });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

    });

  }*/

  reportConfigurationRun() {

    //this.columnNames = this.data.columnNames;

    console.log(this.columnNames);

    console.log(this.rowsData);

    var columnsDefsAnother = [];

    for (var i = 0; i < this.columnNames.length; i++) {
      columnsDefsAnother.push({
        headerName: this.columnNames[i],
        headerTooltip: this.columnNames[i],
        tooltipValueGetter: params => params.value,
        field: this.columnNames[i],
        filter: 'agTextColumnFilter',
        width: 150
      });
    }
    console.log(this.xKeydata)
    console.log(this.ykeydata)
  //   this.options = {
  //     data: this.rowsData,
  //     padding: {
  //       top: 40,
  //       right: 40,
  //       bottom: 40,
  //       left: 40,
  //     },
  //     series: [{
  //         type: 'column',
  //         xKey: this.xKeydata,
  //         yKeys: this.ykeydata,
  //         grouped: true,
  //         label: {},
  //         strokeWidth: 0,
  //     }],
  //     legend: {
  //       spacing: 40,
  //     },
  // };

    //Array to bind data to ag-grid.
    this.columnDefsForReportingConfiguration = columnsDefsAnother;

    this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);


  }

  modifingCharts(){
    let xAxis2;
    let yAxis2;
    let data:any =[];
    this.xdata = [];
    console.log(this.rowsData)
    console.log(this.xKeydata)
    console.log(this.ykeydata)
    for(let i =0;i<=this.rowsData.length-1;i++){
      let xdummy="";
      let ydummy="";
      console.log(Object.keys(this.rowsData[i]))
      console.log(Object.values(this.rowsData[i]))
      for(let j = 0;j<=this.xKeydata.length-1;j++){
        if(Object.keys(this.rowsData[i]).includes(this.xKeydata[j])){
          this.xAxis1 = this.rowsData[i]
          xAxis2 = this.xKeydata[j]
          if(xdummy == ""){
            xdummy = this.xAxis1[xAxis2];
          }else{
          xdummy = xdummy+","+ this.xAxis1[xAxis2];
        }
      }
    }
        for(let y = 0;y<=this.ykeydata.length-1;y++){
          if(Object.keys(this.rowsData[i]).includes(this.ykeydata[y])){
            this.yAxis1 = this.rowsData[i]
            yAxis2 = this.ykeydata[y]
              ydummy = this.yAxis1[yAxis2];
           
          }
          let tempData = { "xAxis": xdummy, "yAxis":ydummy};

          this.xdata.push(tempData);
          console.log(this.xdata)
        }
        
      

    }
    this.xdummydata="";
  }

  barChart(){
    this.modifingCharts()
    this.barChartData = !this.barChartData
    if(this.barChartData == false){
      this.showgridData = true;
    }else{
      this.showgridData = false;
    }
    this.pieChartData = false;

    console.log(this.xdata)
    this.options = {
      data: this.xdata,
      padding: {
        top: 40,
        right: 40,
        bottom: 40,
        left: 40,
      },
      series: [{
          type: 'column',
          xKey: ['xAxis'],
          yKeys:['yAxis'],
          yNames: [
            this.ykeydata
          ],
          label: {},
          strokeWidth: 0,
          grouped:true
      }],
      axes: [
        {
          type: 'category',
          position: 'bottom',
          label: { rotation: 30 },
        },
        {
          type: 'number',
          position: 'left',
          label: {
            formatter: function (params) {
              return params.value;
            },
          },
        },
      ],
      legend: {
        spacing: 40,
        position: 'bottom',
      },
  };


  }
  pieChart(){
    this.modifingCharts()
    console.log(this.ykeydata.length)
    this.pieChartData = !this.pieChartData
    if(this.pieChartData == false){
      this.showgridData = true;
    }else{
      this.showgridData = false;
    }
    this.barChartData = false;
    if(this.ykeydata.length>1){
      this.showgridData=true;
      this.pieChartData = !this.pieChartData
      this.snackbar.open("Pie chart not available","OK", { duration: 5000 })
    }else{
    this.options = {
      data: this.xdata,
      series: [{
          type: 'pie',
          labelKey: ['xAxis'],
          angleKey:['yAxis'],
          angleNames:[this.ykeydata]
      }],
      legend: {
        position: 'bottom',
      },
  };
}
  }

  //Excel export function.
  onExport() {
    this.gridApiForReportingConfiguration.exportDataAsCsv();
  }

  //Pagination code.
  onPaginationChanged() {
    if (this.gridApiForReportingConfiguration) {
      this.lastPage = this.gridApiForReportingConfiguration.paginationIsLastPageFound();
      this.currentPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridApiForReportingConfiguration.paginationGetTotalPages();
    }
  }

  //Below function is to load the ag-grid.
  onGridReadyForReportingConfiguration(params) {

    this.gridApiForReportingConfiguration = params.api;

    params.api.setGridOption('rowData', this.rowsData);

  }

  //this function is for going to the given page number.
  onSearchChange(searchValue: number) {
    this.gridApiForReportingConfiguration.paginationGoToPage(searchValue - 1);
  }

  //Below function is for changing the no of rows per page.
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridApiForReportingConfiguration.setGridOption('paginationPageSize', Number(value));
  }

  //Below function is for going to next page.
  onBtNext() {
    this.gridApiForReportingConfiguration.paginationGoToNextPage();
  }

  //Below function is for going to previous page.
  onBtPrevious() {
    this.gridApiForReportingConfiguration.paginationGoToPreviousPage();
  }

  //Below function is for going to first page.
  onBtFirst() {
    this.gridApiForReportingConfiguration.paginationGoToFirstPage();
  }

  //Below function is for going to last page.
  onBtLast() {
    this.gridApiForReportingConfiguration.paginationGoToLastPage();
  }
  //Below function is for going to next page.
  onNext() {
    this.gridApiForReportingConfiguration.paginationGoToNextPage();
  }

  //Below function is for going to previous page.
  onPrevious() {
    this.gridApiForReportingConfiguration.paginationGoToPreviousPage();
  }

  //Below function is for going to first page.
  onFirst() {
    this.gridApiForReportingConfiguration.paginationGoToFirstPage();
  }

  //Below function is for going to last page.
  onLast() {
    this.gridApiForReportingConfiguration.paginationGoToLastPage();
  }

  formValidationsWhere() {
    // form validations  
    this.formValidWhere = new UntypedFormGroup({
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
      fieldsAggredateBy:new UntypedFormControl('',[]),
      arrangeaggregateBy:new UntypedFormControl('',[])
    });
  }

  formValidationsGroupBy() {
    // form validations  
    this.formValidGroupBy = new UntypedFormGroup({
      fieldsGroupBy: new UntypedFormControl('', [Validators.required])
    });
  }

  formValidationsOrderBy() {
    // form validations  
    this.formValidOrderBy = new UntypedFormGroup({
      
    });
  }

  connect() {

    console.log(this.whereData);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);

      this.formFieldsTrimer.clean(this.whereData);

    }

  }

  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Starts With", value: "Starts with" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "Contains" },
    { name: "Greater than or equals", value: ">=" },
    { name: "Is greater than", value: ">" },
    { name: "Less than or equals", value: "<=" },
    { name: "Is less than", value: "<" },
  ];

  logicalOperatorDataWhere: LogicalOperatorTypeWhere[] = [
    { name: "And", value: "And" },
    { name: "Or", value: "Or" }
  ];

  arrangeDataOrderBy: ArrangeTypeOrderBy[] = [
    { name: "Ascending", value: "ASC" },
    { name: "Descending", value: "DESC" }
  ];

  arrangeDataBy: AggregateDataBy[] = [
    { name: "Average", value: "avg" },
    { name: "Count", value: "count" },
    { name: "Group Concate", value: "group_concat" },
    { name: "Max", value: "max" },
    { name: "Min", value: "min" },
    { name: "Sum", value: "sum" },
  ];



  addWhere() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);
      this.formFieldsTrimer.clean(this.whereData);
      if(this.whereData.fieldsWhere==undefined || this.whereData.conditionalOperatorWhere == undefined || (this.whereData.enterValueWhere == undefined && this.whereData.enterValueWhereDate == undefined)){
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      }else{
      if(this.whereData.logicalOperatorWhere==undefined){
        this.whereData.logicalOperatorWhere="AND"
      }
      console.log(this.whereData.enterValueWhereDate)
      console.log(this.whereData.enterValueWhere)
      if(this.whereData.enterValueWhereDate== undefined){
        let tempWhere = { "whereKey": this.whereData.fieldsWhere, "whereCondition": this.whereData.conditionalOperatorWhere, "whereValue": this.whereData.enterValueWhere, "whereLogic": this.whereData.logicalOperatorWhere }
      
        this.where.push(tempWhere);
        this.showFilter= true;
        this.whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "logicalOperatorWhere": "","enterValueWhereDate":"" };
  
        tempWhere = { "whereKey": "", "whereCondition": "", "whereValue": "", "whereLogic": "" }
      }else{
        this.whereValueDateFormat =moment(this.whereData.enterValueWhereDate) 
        this.whereData.enterValueWhereDate = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        console.log(this.whereData.enterValueWhereDate)
        let tempWhere = { "whereKey": this.whereData.fieldsWhere, "whereCondition": this.whereData.conditionalOperatorWhere, "whereValue": this.whereData.enterValueWhereDate, "whereLogic": this.whereData.logicalOperatorWhere }
      
        this.where.push(tempWhere);
        this.showFilter= true;
        this.whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "logicalOperatorWhere": "","enterValueWhereDate":"" };
  
        tempWhere = { "whereKey": "", "whereCondition": "", "whereValue": "", "whereLogic": "" }

      }
      


      console.log(this.where);

      this.formValidWhere.reset();

      this.formValidationsWhere();
    }

    }

  }

  addGroupBy() {

    if (!this.formValidGroupBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidGroupBy);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.groupByData);

      this.formFieldsTrimer.clean(this.groupByData);

      console.log(this.groupByData.fieldsGroupBy);

      this.groupBy.push(this.groupByData.fieldsGroupBy);

      console.log(this.groupBy);

      this.groupByData = { "fieldsGroupBy": "" };

      console.log(this.groupByData);

      this.formValidGroupBy.reset();

      this.formValidationsGroupBy();

    }

  }

  addOrderBy() {
    if (!this.formValidOrderBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidOrderBy);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.orderByData);
      this.formFieldsTrimer.clean(this.orderByData);
      if(this.orderByData.fieldsOrderBy == undefined){
          this.snackbar.open("Not a valid Sorting", "OK", { duration: 5000 });
      }else{
      if(this.orderByData.arrangeOrderBy==undefined){
        this.orderByData.arrangeOrderBy="ASC";
      }
      let tempOrderBy = { "orderKey": this.orderByData.fieldsOrderBy, "orderAllign": this.orderByData.arrangeOrderBy };

      this.orderBy.push(tempOrderBy);
      this.showOrderBy = true;

      this.orderByData = { "fieldsOrderBy": "", "arrangeOrderBy": "" };

      tempOrderBy = { "orderKey": "", "orderAllign": "" };

      console.log(this.orderBy);

      this.formValidOrderBy.reset();

      this.formValidationsOrderBy();
    }

    }

  }

  addAggregate() {
    this.showAggregate = false;
    if (!this.formValidOrderBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidOrderBy);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.aggregateByData);

      this.formFieldsTrimer.clean(this.aggregateByData);
      if(this.aggregateByData.fieldsAggregateBy == undefined){
        this.snackbar.open("Not a valid Aggregation", "OK", { duration: 5000 });
    }else{
      if(this.aggregateByData.arrangeaggregateBy!=undefined){
      let tempOrderBy = { "aggregateKey": this.aggregateByData.fieldsAggregateBy, "aggregate": this.aggregateByData.arrangeaggregateBy };

      this.aggregateBy.push(tempOrderBy);
      this.showAggregate=true;

      this.aggregateByData = { "fieldsAggregateBy": "", "arrangeaggregateBy": "" };

      tempOrderBy = { "aggregateKey": "", "aggregate": "" };

      console.log(this.aggregateBy);

      this.formValidOrderBy.reset();

      this.formValidationsOrderBy();
    }
    if(this.aggregateBy.length ==0){
      this.showAggregate = false;
    }

    }
  }

  }

  deleteWhere(k){
    console.log(k)
    this.where.splice(k,1);
    if(this.where.length ==0){
      this.showFilter = false;
    }
  }
  deleteOrder(k){
    console.log(k)
    this.orderBy.splice(k,1);
    if(this.orderBy.length ==0){
      this.showOrderBy = false;
    }
  }
  deleteAggregate(k){
    console.log(k)
    this.aggregateBy.splice(k,1);
    if(this.aggregateBy.length ==0){
      this.showAggregate = false;
    }
  }

  closePopup(){
    this.dialogref.close();
  }
}

